import '../../../styles/adminVariables.css';
import styled from 'styled-components';

export const H1 = styled.h1`
margin-bottom:2rem;
`;